import * as Yup from 'yup'
import LookupType from './LookupType'

const noTakeOffFormFinishSelectionErrorMessage = `"Take Off Form and Finish" selection required`

const GuniteWorkOrderMeasurements = Yup.object().shape({
    id: Yup.number().nullable(),
    gunite_work_order_id: Yup.number().nullable(),
    length: Yup.string().nullable(),
    width: Yup.string().nullable(),
    height: Yup.string().nullable(),
    is_take_off_form_and_finish: Yup.boolean().typeError(noTakeOffFormFinishSelectionErrorMessage)
})

const GuniteWorkOrderCrewMember = Yup.object().shape({
    id: Yup.number().nullable(),
    gunite_work_order_id: Yup.number().nullable(),
    employee_id: Yup.number().nullable(),
    employee_name: Yup.string().nullable()
})

export const GunitePerimetersSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    actual_perimeter: Yup.string().nullable(),
    depth_low: Yup.string().nullable(),
    depth_mid: Yup.string().nullable(),
    depth_high: Yup.string().nullable(),
    pool_wall_thickness: Yup.string().nullable(),
    pool_floor_thickness: Yup.string().nullable(),
    is_perimeter_section_complete: Yup.boolean()

})

export const GuniteSpaSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    is_spa_only: Yup.boolean(),
    is_separate_spa: Yup.boolean(),
    spa_raised_low: Yup.string().nullable(),
    spa_raised_mid: Yup.string().nullable(),
    spa_raised_high: Yup.string().nullable(),
    is_take_off_form_and_finish: Yup.boolean().typeError(noTakeOffFormFinishSelectionErrorMessage),
    spa_wall_length: Yup.string().nullable(),
    spa_wall_thickness: Yup.string().nullable(),
    is_deepend_spa: Yup.boolean(),
    is_rolled_beam_spa: Yup.boolean(),
    is_spa_section_complete: Yup.boolean()
})

export const GunitePoolSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    is_sunshelf: Yup.boolean(),
    is_beach_entry: Yup.boolean(),
    is_deep_end_ramp: Yup.boolean(),
    skimmers: Yup.string().nullable(),
    lights: Yup.string().nullable(),
    is_skimmer_in_ramp: Yup.boolean(),

    // Fields originally from Steps and Benches section
    is_walk_out_steps: Yup.boolean(),
    benches: Yup.string().nullable(),
    total_steps: Yup.string().nullable(),

    // Fields originally from the Pads and Notches section
    waterfall_pad_low: Yup.string().nullable(),
    waterfall_pad_mid: Yup.string().nullable(),
    waterfall_pad_high: Yup.string().nullable(),
    fountain_pad_low: Yup.string().nullable(),
    fountain_pad_mid: Yup.string().nullable(),
    fountain_pad_high: Yup.string().nullable(),
    notch_beam_low: Yup.string().nullable(),
    notch_beam_mid: Yup.string().nullable(),
    notch_beam_high: Yup.string().nullable(),
    equipment_pad_low: Yup.string().nullable(),
    equipment_pad_mid: Yup.string().nullable(),
    equipment_pad_high: Yup.string().nullable(),

    is_pool_section_complete: Yup.boolean()
})

export const GuniteRaisedSectionSchema = Yup.object().shape({
    id: Yup.number().required(), 
    job_detail_id: Yup.number().required(),
    raised_beams: Yup.array().of(GuniteWorkOrderMeasurements).nullable(),
    wing_walls: Yup.array().of(GuniteWorkOrderMeasurements).nullable(),
    plantar_walls: Yup.array().of(GuniteWorkOrderMeasurements).nullable(),
    retaining_walls: Yup.array().of(GuniteWorkOrderMeasurements).nullable(),
    pool_out_of_ground: Yup.array().of(GuniteWorkOrderMeasurements).nullable(),
    is_raised_section_complete: Yup.boolean()
})

export const GuniteMaterialsUsedSchema = Yup.object().shape({
    id: Yup.number().required(), 
    job_detail_id: Yup.number().required(),
    steel: Yup.string().nullable(),
    pegboard: Yup.string().nullable(),
    yards: Yup.string().nullable(),
    is_material_section_complete: Yup.boolean()
})

export const GuniteBoulderCreationsSchema = Yup.object().shape({
    id: Yup.number().required(), 
    job_detail_id: Yup.number().required(),
    is_slide: Yup.boolean(),
    is_grotto: Yup.boolean(),
    is_gunited: Yup.boolean(),
    boulder_creations_yardage: Yup.string().nullable(), 
    is_boulder_creations_section_complete: Yup.boolean()
})

export const GuniteExtrasSchema= Yup.object().shape({
    id: Yup.number().required(), 
    job_detail_id: Yup.number().required(),
    is_ayudo: Yup.boolean(),
    is_no_ayudo: Yup.boolean(),
    is_ayudo_poco: Yup.boolean(),
    is_ayudo_mucho: Yup.boolean(),
    muck_out_time: Yup.string().nullable(),
    is_extras_section_complete: Yup.boolean()
})

export const GuniteCrewSchema = Yup.object().shape({
    id: Yup.number().required(), 
    job_detail_id: Yup.number().required(),
    crew_members: Yup.array().of(GuniteWorkOrderCrewMember).nullable(), 
    crew: LookupType.nullable(),
    is_crew_section_complete: Yup.boolean()
})